import {Box} from 'platform/foundation';

import {defaultTo, head, isNotNil} from 'ramda';

import i18n from '@dms/i18n';
import {queryParams, RestrictedArea, usePermissions} from '@dms/shared';
import {Audit, getAudit, InspectionHeader, useThunkDispatch} from '@dms/teas';

import {useOnMount, useQueryState} from 'shared/web';

import {useFetchAuditStructure} from '../hooks/useFetchAuditStructure';

interface InspectionDetailComponentProps {
  vehicleId: string;
  inspectionId: string;
  isRent: boolean;
}

export function InspectionDetailComponent(props: InspectionDetailComponentProps) {
  const dispatch = useThunkDispatch();

  const [activeInspectionTab, setActiveInspectionTab] = useQueryState(
    queryParams.RENTAL_ORDER_INSPECTION
  );

  const {fetchAuditStructure} = useFetchAuditStructure();

  useOnMount(() => {
    dispatch(
      getAudit.action({
        auditId: props.inspectionId,
      })
    )
      .unwrap()
      .then((response) => {
        if (isNotNil(response)) {
          fetchAuditStructure(head(response));
        }
      });
  });

  return (
    <Audit
      data-testid="inspection"
      notFoundText={i18n.t('entity.condition.notifications.inspectionNotFound')}
      vehicleId={props.vehicleId}
      activeTab={defaultTo(undefined, activeInspectionTab)}
      onTabChange={setActiveInspectionTab}
      isBodyOnly
      header={
        <InspectionHeader
          data-testid="inspection-header"
          inspectionId={props.inspectionId}
          vehicleId={props.vehicleId}
          isSinglePage
        />
      }
    />
  );
}

export function InspectionDetail(props: InspectionDetailComponentProps) {
  const [hasReadInspectionPermission] = usePermissions({
    permissionKeys: ['readInspection'],
    scopes: {
      readInspection: {
        inspectionType: 'SKIP',
        // INTENDED
        participation: 'SKIP',
      },
    },
  });

  if (!hasReadInspectionPermission) {
    return (
      <Box width="100%">
        <RestrictedArea />
      </Box>
    );
  }

  return <InspectionDetailComponent {...props} />;
}
